import React from 'react';
import type { DepthRange } from './sweetSpotDepth';

type Props = {
  selectedDepth: number | null;
  visibleRange: DepthRange | null;
  plotTop?: number;
  plotBottom?: number;
  onDragStart: (clientY: number) => void;
};

export default function DepthCursorOverlay({
  selectedDepth,
  visibleRange,
  plotTop = 0,
  plotBottom = 0,
  onDragStart,
}: Props) {
  if (selectedDepth == null || !visibleRange) return null;
  const span = visibleRange[1] - visibleRange[0];
  if (selectedDepth < visibleRange[0] || selectedDepth > visibleRange[1]) return null;
  const ratio = span > 0 ? (selectedDepth - visibleRange[0]) / span : 0.5;
  const offset = plotTop - ratio * (plotTop + plotBottom);
  const top = `calc(${(ratio * 100).toFixed(6)}% + ${offset.toFixed(2)}px)`;

  return (
    <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none', zIndex: 4 }}>
      <div
        role="slider"
        aria-orientation="vertical"
        aria-label="深度游标"
        aria-valuemin={visibleRange[0]}
        aria-valuemax={visibleRange[1]}
        aria-valuenow={selectedDepth}
        title="上下拖动深度游标"
        onMouseDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onDragStart(event.clientY);
        }}
        style={{
          position: 'absolute', left: 0, right: 0, top, height: 12,
          transform: 'translateY(-6px)', cursor: 'ns-resize', pointerEvents: 'auto',
        }}
      >
        <div style={{
          position: 'absolute', left: 0, right: 0, top: 5,
          borderTop: '1px dashed #C2533A', boxShadow: '0 1px 0 rgba(255,255,255,0.85)',
        }} />
        <span style={{
          position: 'absolute', left: 58, top: -18, padding: '2px 7px', borderRadius: 3,
          background: '#C2533A', color: '#FFFFFF', fontSize: 10, fontWeight: 700,
          whiteSpace: 'nowrap', boxShadow: '0 2px 5px rgba(30,42,58,0.18)',
        }}>
          当前深度 {selectedDepth.toFixed(1)} m
        </span>
      </div>
    </div>
  );
}
